/*
 * Basic MapCache entry for tracking expire times.
 */
class Entry {
    #expires = false;
    #ttl = false;
    #data = false;

    constructor(data, duration = false) {
        this.#data = data;
        this.#ttl = duration;
        this.#expires = duration ? Date.now() + duration : false;
    }

    expired() {
        return this.#expires && this.#expires <= Date.now();
    }

    ttl(duration = false) {
        this.#ttl = duration;
        return (this.#expires = duration ? Date.now() + duration : false);
    }

    data() {
        return !this.expired() ? this.#data : (this.#data = undefined);
    }
}

/*
 * Use ES6 Map() to cache web requests and other object data.
 */
export default class MapCache extends Map {
    #pruneTimer;
    #evictTimer;

    constructor(limit = 10) {
        super();
        this.timer();
        this.limit = limit;
        this.mechanism = 'map';
    }

    get isCache() {
        return true;
    }

    timer() {
        clearTimeout(this.#pruneTimer);
        this.#pruneTimer = setTimeout(() => this.prune(), 5000);

        return this;
    }

    set(key, value, duration) {
        super.set(key, new Entry(value, duration));
        clearInterval(this.#evictTimer);
        this.#evictTimer = setTimeout(() => this.evict(), 50);

        return this;
    }

    get(key, data = true, duration) {
        let value = undefined;
        if (this.has(key)) {
            value = super.get(key);
            super.delete(key);
            super.set(key, value);
            if (duration) value?.ttl?.(duration);
        }

        return value && data ? value.data?.() : value;
    }

    prune() {
        for (const [key, value] of this.entries()) {
            if (value.expired()) this.delete(key);
        }

        return this.timer();
    }

    evict(keys = false) {
        if (keys) {
            keys.forEach(key => key ? this.delete(key) : false);
        } else {
            let keys = this.keys();
            while (this.size > this.limit) this.delete(keys.next().value);
        }

        return this;
    }
}
